import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchIntentProjectsArgs, SearchIntentProjectsOutput } from "types/generated";

import { INTENT_PROJECT_BASIC_FRAGMENT } from "../gql";

export const SEARCH_INTENT_PROJECTS: TypedDocumentNode<
  { searchIntentProjects: SearchIntentProjectsOutput } & QuerySearchIntentProjectsArgs
> = gql`
  query SearchIntentProjects($input: SearchInput!) {
    searchIntentProjects(input: $input) {
      edges {
        cursor
        node {
          ...IntentProjectBasic
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
  ${INTENT_PROJECT_BASIC_FRAGMENT}
`;
